function Suggested({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.48 0C9.44 0 0.5 8.96 0.5 20C0.5 31.04 9.44 40 20.48 40C31.54 40 40.5 31.04 40.5 20C40.5 8.96 31.54 0 20.48 0ZM35.44 14.32L25.42 13.46L21.42 4.04C27.84 4.42 33.24 8.58 35.44 14.32ZM25.3 26.84L20.5 23.96L15.72 26.84L16.98 21.4L12.76 17.74L18.32 17.26L20.5 12.12L22.68 17.24L28.24 17.72L24.02 21.38L25.3 26.84ZM19.58 4.04L15.58 13.48L5.54 14.34C7.74 8.58 13.14 4.4 19.58 4.04ZM4.5 20C4.5 18.72 4.66 17.48 4.96 16.28L12.54 22.84L10.32 32.34C6.76 29.4 4.5 24.96 4.5 20ZM12.18 33.64L20.5 28.62L28.82 33.62C26.38 35.12 23.54 36 20.48 36C17.44 36 14.6 35.12 12.18 33.64ZM30.68 32.34L28.46 22.84L36.04 16.28C36.32 17.46 36.5 18.72 36.5 20C36.5 24.96 34.22 29.4 30.68 32.34Z" fill=${`"${col}"`}/>
    </svg>

  `;

  return baseXml;
}

export default Suggested;
